import { Workspace } from "./workspace";

export enum SubscriptionIntervals {
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export enum PaymentProvider {
  STRIPE = "stripe",
  SHOPIFY = "shopify",
}

export enum ActiveStatus {
  ACTIVE = "AC",
  PAUSED = "PA",
  INACTIVE = "IN",
  PAST_DUE = "PD",
}

export interface Limits {
  resolutions_per_month: number;
  seats: number;
  phone_calls_per_month: number;
  store_access: boolean;
  premium_models: boolean;
  custom_branding: boolean;
  reasoning_ai: boolean;
}

export interface SubscriptionPlan {
  id: number;
  interval: SubscriptionIntervals;
  status: ActiveStatus;
  cost_per_month: number;
  old_cost_per_month?: number | null;
  created_at: string;
  updated_at: string;
  features: any[];
  limits: Limits;
  trial_days: number;
  name?: string | null;
  is_highlighted: boolean;
  months_off: number;
  stripe_plan_id?: string | null;
}

export interface Subscription {
  id: number;
  workspace?: Workspace | null;
  plan: SubscriptionPlan;
  status: ActiveStatus;
  external_id?: string | null;
  payment_provider: PaymentProvider;
  created_at: string;
  updated_at: string;
  cancel_at?: string | null;
  cancelled_at?: string | null;
  trial_end_at?: string | null;
  paused_at?: string | null;
}
